var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "d-flex flex-column my-0 fill-height py-0",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-card', {
    staticClass: "mt-8 mb-2 rounded-lg",
    attrs: {
      "loading": _vm.loading ? 'white' : false
    }
  }, [_c('v-card-title', {
    staticClass: "primary white--text pa-3"
  }, [_c('v-row', {}, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }), _c('v-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.stagesFiltered,
      "item-value": "xid",
      "item-text": "title",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "dark": "",
      "hide-details": "",
      "placeholder": "Job Stage",
      "clearable": ""
    },
    model: {
      value: _vm.stage,
      callback: function callback($$v) {
        _vm.stage = $$v;
      },
      expression: "stage"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    staticClass: "mr-4",
    attrs: {
      "placeholder": "Filter...",
      "append-icon": "mdi-magnify",
      "dark": "",
      "dense": "",
      "outlined": "",
      "rounded": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: _vm.filterAuto,
      callback: function callback($$v) {
        _vm.filterAuto = $$v;
      },
      expression: "filterAuto"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "width": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "pa-0 d-flex",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "flex-grow-1 mx-2"
  }, [_c('div', {
    staticClass: "fill-height d-flex flex-column",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "mt-4"
  }, [_c('span', {
    staticClass: "text-subtitle-2 primary--text"
  }, [_c('v-icon', {
    staticClass: "primary--text mr-4"
  }, [_vm._v("mdi-playlist-star")]), _vm._v("Top Priorities")], 1)]), _c('div', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('PriorityList', {
    ref: "priorityList",
    attrs: {
      "jobs": _vm.jobs,
      "queue": _vm.priority_queue
    },
    on: {
      "prioritiseIntent": _vm.prioritise,
      "rightClick": _vm.rightClickPriority
    }
  })], 1)])]), _c('div', {
    staticClass: "flex-grow-1 mx-2"
  }, [_c('div', {
    staticClass: "fill-height d-flex flex-column",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "text-subtitle-2 primary--text"
  }, [_c('v-icon', {
    staticClass: "primary--text mr-4"
  }, [_vm._v("mdi-auto-fix")]), _c('span', [_vm._v("Auto Prioritisation")])], 1)]), _c('div', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('AutoList', {
    ref: "autoList",
    attrs: {
      "jobs": _vm.jobs,
      "queue": _vm.auto_queue,
      "stage": _vm.stage,
      "filter": _vm.filterAuto
    }
  })], 1)])])])]), _c('v-menu', {
    ref: "JobContextMenu",
    attrs: {
      "position-x": _vm.contextmenu.x,
      "position-y": _vm.contextmenu.y,
      "absolute": "",
      "offset-y": ""
    },
    model: {
      value: _vm.contextmenu.show_right,
      callback: function callback($$v) {
        _vm.$set(_vm.contextmenu, "show_right", $$v);
      },
      expression: "contextmenu.show_right"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": _vm.context_unprioritise
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-arrow-right")]), _vm._v("Unprioritise")], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }